const mailchimpScript = document.createElement('script');
mailchimpScript.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
mailchimpScript.id = 'mailchimp';

mailchimpScript.paypalExpress = "false";

export default mailchimpScript;
